import {
    TbAntenna,
    TbBuilding,
    TbBuildingFactory,
    TbBuildingFactory2,
    TbCloud,
    TbCpu,
    TbHome,
    TbServer,
} from 'react-icons/tb';

const customIcons = [
    {
        type: 'cloud',
        label: 'Cloud',
        Icon: TbCloud,
    },
    {
        type: 'cpu',
        label: 'CPU',
        Icon: TbCpu,
    },
    {
        type: 'server',
        label: 'Server',
        Icon: TbServer,
    },
    {
        type: 'antenna',
        label: 'Antenna',
        Icon: TbAntenna,
    },
    {
        type: 'house',
        label: 'House',
        Icon: TbHome,
    },
    {
        type: 'building',
        label: 'Building',
        Icon: TbBuilding,
    },
    {
        type: 'factory',
        label: 'Factory',
        Icon: TbBuildingFactory,
    },
    {
        type: 'factory2',
        label: 'Plant',
        Icon: TbBuildingFactory2,
    },
] as const;

export { customIcons };
